import { useState } from "react";
import { Modal } from "react-bootstrap";
import type { SegmentLinkItem } from "@services/engagements/commands/cmdGetSegmentLinks";

type Props = {
  title: string;
  segmentName: string;
  candidates: readonly SegmentLinkItem[];
  isSaving: boolean;
  onClose: () => void;
  onLink: (entityId: number) => void;
};

/*
    The population page's inverse picker: instead of "pick a population for
    this entity", pick which unlinked entity to attach to THIS population.
    Candidates are only entities with no population today — moving one off
    another population is done from the entity's own page, where the
    change warning lives.
*/
export default function LinkEntityModal({
  title,
  segmentName,
  candidates,
  isSaving,
  onClose,
  onLink,
}: Props) {
  const [value, setValue] = useState("");
  const canSave = value !== "" && !isSaving;

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1rem" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="small text-muted mb-3">
          Population: <span className="fw-semibold">{segmentName}</span>
        </div>
        <select
          className="form-select"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          aria-label={title}
        >
          <option value="">Choose…</option>
          {candidates.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          disabled={!canSave}
          onClick={() => onLink(Number(value))}
        >
          Link
        </button>
      </Modal.Footer>
    </Modal>
  );
}
